import React from 'react';
import ContactForm from '../containers/ContactForm';

const Contact = () => {
  return (
    <div className="centered">
      <h2>Contact Us</h2>
      <ContactForm />
    </div>
  );
};

export default Contact;